// extracted by mini-css-extract-plugin
module.exports = {"d":"block-d_d__2G97w","d2":"block-d_d2__XyPgx","flex":"block-d_flex__2vedA","header":"block-d_header__WNFjg","body":"block-d_body__1SYhc"};